import styled from 'styled-components';
import React, { forwardRef } from 'react';

const BannerWrap = styled.div``;

interface BannerProps {
  img: string;
  onClick?: () => void;
}

const Banner = forwardRef(({ img, onClick }: BannerProps, ref: React.ForwardedRef<HTMLImageElement>): JSX.Element => {
  return (
    <BannerWrap>
      <img src={img} onClick={onClick} alt="" ref={ref} />
    </BannerWrap>
  );
});
export default Banner;
